/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
try {
(function() {
  // Add custom code below this line
  
  // Override the header breakpoint
  window.theme.Header.prototype.getMinWidth = function() {
    return 1300;
  };

  // Override the isDesktop and isMobile functions
  window.theme.isDesktop = function() {
    return getWindowWidth() >= 1300;
  };

  window.theme.isMobile = function() {
    return getWindowWidth() < 1300;
  };

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
} catch (error) {}

document.addEventListener("DOMContentLoaded", function() {
  const megaMenuItems = document.querySelectorAll('.menu__item.grandparent');

  megaMenuItems.forEach(function(item) {
    const originalToggleLink = item.querySelector('.navlink--toplevel');
    const dropdown = item.querySelector('.header__dropdown');

    if (originalToggleLink && dropdown) {
      
      // 1. CLONE THE LINK: This strips away the theme's hidden Javascript event listeners
      const toggleLink = originalToggleLink.cloneNode(true);
      originalToggleLink.parentNode.replaceChild(toggleLink, originalToggleLink);

      // 2. Add our clean Click Event Listener
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault(); 
        e.stopPropagation(); // Stops the theme from detecting this click elsewhere
        e.stopImmediatePropagation();

        const isOpen = dropdown.classList.contains('mega-menu-open');

        // Close any other open mega menus first
        document.querySelectorAll('.header__dropdown.mega-menu-open').forEach(function(openDropdown) {
          if (openDropdown !== dropdown) {
            openDropdown.classList.remove('mega-menu-open');
          }
        }); 

        // Toggle our custom class
        if (!isOpen) {
          dropdown.classList.add('mega-menu-open');
        } else {
          dropdown.classList.remove('mega-menu-open');
        }
      });

      // 3. Prevent clicks INSIDE the dropdown from closing it
      dropdown.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  });

  // 4. Close the menu when clicking outside of it
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.menu__item.grandparent')) {
      document.querySelectorAll('.header__dropdown.mega-menu-open').forEach(function(dropdown) {
        dropdown.classList.remove('mega-menu-open');
      });
    }
  });
});
